import { Component, Model, Prop, Vue } from 'nuxt-property-decorator';
// @ts-ignore
import { directive } from 'v-click-outside-x';
@Component<InputIcon>({
  directives: {
    clickOutside: directive
  },
  data() {
    return {
      defaultValue: this.inputValue,
      selectedList: [],
      selectOpen: false
    }
  }
})
export default class InputIcon extends Vue {
  @Model('input', { type: String })
  inputValue!: string;

  @Prop({ type: String })
  value!: string;

  @Prop({ type: String })
  placeholder!: string;

  @Prop({ type: Array })
  options!: [Object];

  @Prop()
  leftIcon!: any;

  @Prop()
  rightIcon!: any;

  @Prop({ type: String })
  pattern!: string;

  // State
  @Prop({ type: Boolean, default: false })
  readonly!: boolean;

  @Prop({ type: Boolean, default: false })
  disabled!: boolean;

  @Prop({ type: Boolean, default: false })
  error!: boolean;

  updated(): void {
    if (this.$data.defaultValue !== this.$props.value) {
      this.$data.defaultValue = this.$props.value;
    }
  }

  get hasLeftIcon(): boolean {
    return !!this.$props.leftIcon;
  }

  get hasRightIcon(): boolean {
    return !!this.$props.rightIcon;
  }

  get hasSlot(): boolean {
    return !!this.$slots.default;
  }

  get hasOptions(): boolean {
    return !!this.$props.options;
  }

  filterOptions(options: any[]): any[] {
    if (this.inputValue) {
      return options.filter(item => {
        const value = item && item.text && item.text.toString().toLowerCase();
        const inputValue = this.inputValue && this.inputValue.toLowerCase();

        return value.includes(inputValue);
      });
    }

    return options;
  }

  optionIsSelected(item: any): boolean {
    return this.$data.selectedList.includes(item);
  }

  updateInput(value: string): void {
    this.$emit('input', value);

    if (value) {
      this.$data.selectOpen = true;
    } else {
      this.$data.selectOpen = false;
    }
  }

  inputAction(e: Event): void {
    if (this.hasSlot) {
      this.$emit('iconClick', e);
    } else {
      this.$data.selectOpen = !this.$data.selectOpen;
    }
  }

  onClickOutside (e: any): void {
    this.$data.selectOpen = false;
  }
}
